import { get } from 'aws-amplify/api';
import { getValidAuthToken } from '../utils/auth';

export async function fetchResource<T, Q>(
  apiName: string,
  path: string,
  parseResponse: (response: any) => T[],
  queryParams: Q,
  signal?: AbortSignal,
): Promise<T[]> {
  const authToken = await getValidAuthToken();
  if (signal?.aborted) throw new DOMException('Request aborted', 'AbortError');
  const restOperation = get({
    apiName,
    path,
    options: {
      headers: { Authorization: authToken || '' },
      queryParams: queryParams as Record<string, string>,
    },
  });

  const cancel = () => restOperation.cancel();
  signal?.addEventListener('abort', cancel, { once: true });
  try {
    const response = await restOperation.response;
    if (response.body instanceof ReadableStream) {
      const reader = response.body.getReader();
      const decoder = new TextDecoder();
      let result = '';
      try {
        while (true) {
          const { done, value } = await reader.read();
          if (done) break;
          result += decoder.decode(value, { stream: true });
        }
        result += decoder.decode();
      } finally {
        reader.releaseLock();
      }
      return parseResponse(JSON.parse(result));
    }
    return parseResponse(await response.body.json());
  } finally {
    signal?.removeEventListener('abort', cancel);
  }
}
